import React from 'react';
import { useSelector } from 'react-redux';
import {
    Box,
    Typography,
} from "@mui/material";
import MessageDataGrid from './MessageDataGrid';
import Page from '../../components/Page';
import { useUserMessages } from '../../hooks/useMessages';

const CustomersPage = () => {
    /// container page for messages for customers
    const currentCompany = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const { data: allMessages = [] } = useUserMessages({
        userOrCompanyId: currentCompany?.id,
        enabled: Boolean(currentCompany?.id),
    });

    const message = [];
    const rows = message;

    /// grabs all messages that have a status of anything other than pending
    allMessages?.forEach(messagePusher);
    function messagePusher(allMessages) {
        if (allMessages?.requestStatus != 0){
        message.push({
            id: allMessages.id,
            companyId: allMessages.companyId,
            created: allMessages.created,
            deleted: allMessages.deleted,
            message: allMessages.message,
            requestStatus: allMessages.requestStatus,
            userId: allMessages.userId,
            userEmail: allMessages.userEmail,
            userFirstName: allMessages.userFirstName,
            userLastName: allMessages.userLastName,
            reply: allMessages.reply,
            companyContact: allMessages.companyContact,
            companyCity: allMessages.companyCity,
            companyCountry: allMessages.companyCountry,
            companyEmail: allMessages.companyEmail,
            companyPhoneNumber: allMessages.companyPhoneNumber,
            companyState: allMessages.companyState,
            companyStreet: allMessages.companyStreet,
            companyZip: allMessages.companyZip
        })}
    };

    return(
        <Page title="Contacts">
        <Box style={{paddingRight:'30px'}}>
            <Box sx={{ marginTop: "10px", marginBottom: "10px" }}>
                <Typography textAlign={"center"} color={"blue"} variant='h4'>
                    Messages
                </Typography>
                <Typography variant="h5" >
                    Replies from Processors
                </Typography>
            </Box>
            <MessageDataGrid messages={message}/>
        </Box>
        </Page>
    )
}

export default CustomersPage;